import { defineStore } from "pinia";
import { ref, getCurrentInstance } from "vue";
import Utils from "@/utils/util";
import {
  apiCheckToken,
  apiAffiliateUrl,
  apiVipLevelList,
  apiNotificationList,
  apiCheckIn,
} from "@/api";
import { router } from "@/main";
import { useAppStore } from "./app";
import eventBus from "@/utils/eventBus";
import { createI18nInstance } from "@/config";
import { getImageByLevel } from "@/utils/imageManager";
import { wsClient } from '@/utils/websocket'

export const useUserStore = defineStore("user", () => {
  const isLogin = ref(false);
  const userinfo = ref(Utils.$storageGet("userinfo") || null);
  const checkTokenTimer = ref(null);
  const appStore = useAppStore();
  const affiliateUrl = ref(""); //代理短链接
  const { appContext } = getCurrentInstance();
  const globalProperties = appContext.config.globalProperties;

  const notificationList = ref([]); //消息通知列表
  const notificationUnread = ref(0); //消息通知未读数
  const notificationTimer = ref(null);
  const checkInData = ref({
    sign: 0, //今日是否签到
    sign_in_days: 0, //连续签到天数 不算今日
  });
  const checkInDays = ref([]);
  const otherAccounts = ref([]); //可选择其他账号登录
  const vipLevelData = ref(null); //vip 等级信息 列表
  const vipLevel = ref({
    myLevel: 0, //我的等级
    myLevelByImg: "", //我的等级对应图片
    list: [], //全部等级列表
    isEndLevel: false, //是否最高等级
    myTotalRunwater: 0, //我的总流水
    myTotalDeposit: 0, //我的总充值
    myLevelByBonus: null, //我的等级对应权益
    nextLevelByBonus: null, //下一个等级对应权益
    nextLevelTotalRunwater: 0, //下一个等级总流水
    nextLevelTotalDeposit: 0, //下一个等级总充值
    myTotalRunwaterScale: "0%", //我的总流水比例
    myTotalDepositScale: "0%", //我的总充值比例
  });

  // 校验token 定时
  const checkToken = () => {
    let token = Utils.$storageGet("token");
    if (token) {
      isLogin.value = true;
      getUserinfo(); //获取用户信息
      getAffiliateUrl(); //获取代理链接
      getNotificationList(); //获取通知列表
      getVipLevelList();
      // clearInterval(checkTokenTimer.value);
      // checkTokenTimer.value = setInterval(async () => {
      //   getUserinfo();
      //   getVipLevelList();
      // }, 6000);
      // clearInterval(notificationTimer.value);
      // notificationTimer.value = setInterval(() => {
      //   getNotificationList();
      // }, 10000);
    } else {
      logout();
    }
  };
  // 获取用户信息
  const getUserinfo = async () => {
    if (!isLogin.value) return;
    try {
      const { code, data } = await apiCheckToken();
      switch (code) {
        case 200:
          isLogin.value = true;
          updateUserinfo(data);
          eventBus.emit("CheckToken");
          if (vipLevelData.value) {
            // 如果等级不等，重新拉取等级信息
            if (vipLevelData.value.vip_level !== data.level) {
              getVipLevelList();
            }
          }
          break;
        case 100002:
          clearInterval(checkTokenTimer.value);
          break;
        default:
          router.push("/home");
          logout();
          break;
      }
    } catch (error) {}
  };
  // 登录
  const login = () => {
    isLogin.value = true;
    getAffiliateUrl();
    wsClient.connect();
  };
  // 退出登录
  const logout = () => {
    isLogin.value = false;
    userinfo.value = null;
    try {
      Utils.$storageClear("token");
      Utils.$storageClear("userinfo");
    } catch (e) {
      console.warn("Storage clear error:", e);
    }
    clearInterval(checkTokenTimer.value);
    clearInterval(notificationTimer.value);
    wsClient.disconnect();
    
  };
  // 更新用户信息
  const updateUserinfo = (data) => {
    userinfo.value = data;
    Utils.$storageSet("userinfo", data);
  };
  // 设置币种
  const setCoin = (data) => {
    userinfo.value.vip_coin = data;
    console.log("设置币种", data);
  };

  // 代理 短链接生成
  const getAffiliateUrl = async () => {
    try {
      const { data } = await apiAffiliateUrl({
        route: "login",
        params: {
          ic: userinfo.value.id,
          os_type: 0,
        },
      });
      // console.log(data);
      // affiliateUrl.value = globalProperties.$Href + data;
      affiliateUrl.value = data.share_link;
    } catch (error) {}
  };

  // 获取等级信息及列表
  const getVipLevelList = async () => {
    if (!isLogin.value) return;
    let { data } = await apiVipLevelList();
    // console.log(data)
    // console.log("当前vip",data.current_vip_info)
    vipLevel.value.myLevel = data.current_vip_info.level;
    // vipLevel.value.myLevelByImg = getImageByLevel(data.vip_level);
    vipLevel.value.myLevelByImg = 'https://pg028-api.centuries.cc'+data.current_vip_info.image;
    //TO DO
    if (data.vip_list.length) {
      vipLevel.value.list = data.vip_list.sort((a, b) => {
        return a.level - b.level;
      });
      vipLevel.value.isEndLevel =
        data.current_vip_info.level ===
        vipLevel.value.list[vipLevel.value.list.length - 1].grade;
      // vipLevel.value.myTotalRunwater = Utils.$floatMoney(data.record_total);
      vipLevel.value.signStatus = data.current_vip_info.signStatus
      vipLevel.value.upgradeBonus = data.current_vip_info.upgradeBonus
      vipLevel.value.rechargeBonus = data.current_vip_info.rechargeBonus
      vipLevel.value.lossBonus = data.current_vip_info.lossBonus
      vipLevel.value.signBonus = data.current_vip_info.signBonus
      vipLevel.value.totalBonus = data.current_vip_info.totalBonus
      vipLevel.value.allBonus = data.current_vip_info.allBonus
      
      vipLevel.value.myTotalRunwater = data.current_vip_info.total_bet;
      vipLevel.value.myTotalDeposit = data.current_vip_info.total_recharge;
      const index = vipLevel.value.list.findIndex(
        (v) => v.level === data.current_vip_info.level
      );
      if (index > -1) {
        vipLevel.value.myLevelByBonus = vipLevel.value.list[index];
      }
      if (!vipLevel.value.isEndLevel) {
        vipLevel.value.nextLevelByBonus = vipLevel.value.list[index + 1];
        vipLevel.value.nextLevelTotalRunwater = 
          vipLevel.value.list[index + 1].running_water
        
        vipLevel.value.nextLevelTotalDeposit = 
          vipLevel.value.list[index + 1].running_money
        
        vipLevel.value.myTotalRunwaterScale = !vipLevel.value
          .nextLevelTotalRunwater
          ? "100%"
          : `${
              (
                vipLevel.value.myTotalRunwater /
                vipLevel.value.nextLevelTotalRunwater
              ).toFixed(3) * 100
            }%`;
        vipLevel.value.myTotalDepositScale = !vipLevel.value
          .nextLevelTotalDeposit
          ? "100%"
          : `${
              (
                vipLevel.value.myTotalDeposit /
                vipLevel.value.nextLevelTotalDeposit
              ).toFixed(3) * 100
            }%`;
      }
    }
    vipLevelData.value = data.current_vip_info;
  };

  // 获取通知列表
  const getNotificationList = async () => {
    if (!isLogin.value) return;
    try {
      const { data, code } = await apiNotificationList({
        page: 1,
        limit: 10000,
      });
      if (code === 200) {
        notificationList.value = data;
        getNotificationUnread();
      } else {
        clearInterval(notificationTimer.value);
      }
    } catch (error) {}
  };

  // 统计出通知列表中未读数量
  const getNotificationUnread = async () => {
    // reward_status false 已经领取 true未领取
    // 筛选符合条件的元素
    const filteredArray = notificationList.value.filter(
      (item) => !item.read_status || (item.reward_id && item.reward_status)
    );
    // 获取符合条件的元素数量
    const count = filteredArray.length;
    notificationUnread.value = count;
  };

  // 查询签到情况
  const getCheckIn = async () => {
    if (!isLogin.value) return;
    const { data } = await apiCheckIn(
      {
        type: 2, //1签到 2查询
      },
      false
    );
    const i18n = await createI18nInstance();
    const { t } = i18n.global;
    // console.log(data);
    if (Utils.$isObject(data)) {
      checkInData.value = data;
      const rewards = [];
      // 循环提取 day1_reward 到 day7_reward
      for (let day = 1; day <= 7; day++) {
        const key = `day${day}_reward`;
        if (data.sign_reward[key] !== undefined) {
          rewards.push({
            id: day,
            day: `${t("A0364", { value: day })}`,
            bonus: data.sign_reward[key],
          });
        }
      }
      checkInDays.value = rewards;
      if (!data.sign) {
        // 弹出签到
        eventBus.emit("CheckIn");
      }
    }
  };
  // 初始化其他账号
  const initOtherAccounts = () => {
    const storedItems = Utils.$storageGet("otherAccounts") || [];
    const filteredItems = storedItems.filter((item) =>
      Utils.$isWithinLastSevenDays(item.date)
    );
    otherAccounts.value = filteredItems;
  };
  // 删除其他账号信息
  const delOtherAccountsItem = (item) => {
    let index = otherAccounts.value.findIndex((v) => v.id === item.id);
    if (index > -1) {
      otherAccounts.value.splice(index, 1);
    }
  };
  // 添加新项目到列表中，并处理排序、去重及保留七天内数据
  const addOtherAccounts = (item) => {
    item.date = new Date().toISOString();
    const existingIndex = otherAccounts.value.findIndex(
      (i) => i.id === item.id
    );
    if (existingIndex !== -1) {
      otherAccounts.value.splice(existingIndex, 1);
    }
    otherAccounts.value.unshift(item);
    otherAccounts.value = otherAccounts.value.filter((item) =>
      Utils.$isWithinLastSevenDays(item.date)
    );
    Utils.$storageSet("otherAccounts", otherAccounts.value);
  };

  // 初始化时调用加载本地数据
  initOtherAccounts();
  return {
    isLogin,
    userinfo,
    login,
    logout,
    updateUserinfo,
    checkToken,
    getUserinfo,
    affiliateUrl,
    getAffiliateUrl,
    vipLevelData,
    vipLevel,
    getVipLevelList,
    notificationList,
    notificationUnread,
    getNotificationList,
    getCheckIn,
    checkInData,
    checkInDays,
    otherAccounts,
    delOtherAccountsItem,
    addOtherAccounts,
    setCoin,
  };
});
